import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  async postAppointment(exam, date, time, name, email, phone) {
    try {
      return await axios.post(
        `${process.env.VUE_APP_API_ENDPOINT}/appointment`,
        {
          exam,
          date,
          time,
          name,
          email,
          phone,
        },
      );
    } catch (e) {
      return e.response;
    }
  },
};
